import { combineReducers, createStore, applyMiddleware } from 'redux';
import { Provider, Store } from 'react-redux';
import thunk from 'redux-thunk';
import filterReducer from './reducers/filters';
import mediaApiReducer from './reducers/media-api';
import modalReducer from './reducers/modal';

let combined = combineReducers({
    filterModel: filterReducer,
    mediaApiModel: mediaApiReducer,
    modalModel: modalReducer
});

export var mediaStore = createStore(combined, applyMiddleware(thunk));


// WEBPACK FOOTER //
// ./app/media-gallery/redux/index.ts